import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { colors, transition } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

import Title from "../../atoms/Title";
import OffCanvasTrayClose from "../../atoms/OffCanvasTrayClose";
import WineListCreation from "../../atoms/WineListCreation";

const StyledBottleInfoTrayAddNew = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background-color: ${colors.white};
  z-index: 100;
  transition: ${transition.baseTransition};
  display: ${(props) => (props.isBottleInfoTrayOpened ? "block" : "none")};
`;

const Header = styled.div`
  padding: 27px 15px;
  position: relative;
  text-align: center;
`;

const Body = styled.div`
  padding: 10px 40px 40px 40px;
  box-shadow: 0 4px 3px -2px rgba(0, 0, 0, 0.1);
  ${breakpoints.smDown} {
    padding: 20px 15px;
  }
`;

class BottleInfoTrayAddNew extends Component {
  /**
   * Callback executed when new list is created.
   * @param {Object} data
   */
  onListCreated = (data) => {
    const { handleBottleInfoTrayChange } = this.props;
    handleBottleInfoTrayChange(data);
  };

  render() {
    const { isBottleInfoTrayOpened, handleBottleInfoTrayChange, memberId } = this.props;

    return (
      <StyledBottleInfoTrayAddNew isBottleInfoTrayOpened={isBottleInfoTrayOpened}>
        <Header>
          <OffCanvasTrayClose onClick={() => handleBottleInfoTrayChange(null)} />
          <Title tag={5} uppercase mb0>
            Create new
          </Title>
        </Header>

        <Body>
          <WineListCreation memberId={memberId} onListCreated={this.onListCreated} />
        </Body>
      </StyledBottleInfoTrayAddNew>
    );
  }
}

BottleInfoTrayAddNew.propTypes = {
  memberId: PropTypes.number.isRequired,
  isBottleInfoTrayOpened: PropTypes.bool,
  handleBottleInfoTrayChange: PropTypes.func,
};

BottleInfoTrayAddNew.defaultProps = {
  isBottleInfoTrayOpened: false,
  handleBottleInfoTrayChange: () => {},
};

export default BottleInfoTrayAddNew;
